import { P3 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(
    ${({ numberOfItems }) => (numberOfItems > 3 ? '2' : '1')},
    1fr
  );
  gap: 32px;
  margin-top: ${({ hasMarginTop }) => (hasMarginTop ? '32px' : '0px')};

  ${QUERIES.tabletAndUp} {
    grid-template-columns: repeat(
      ${({ numberOfItems }) => (numberOfItems > 3 ? '3' : '1')},
      1fr
    );
  }
  ${QUERIES.laptopAndUp} {
    grid-template-columns: repeat(${({ numberOfItems }) => numberOfItems}, 1fr);
    gap: 24px;
    margin-top: ${({ hasMarginTop }) => (hasMarginTop ? '48px' : '0px')};
  }
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  text-align: ${({ textAlign }) => textAlign};
`;

export const Image = styled.img.attrs(({ imageType }) => {
  if (imageType === 'small') {
    return {
      width: 65,
      height: 65,
    };
  }
  return null;
})`
  width: ${({ imageType }) => (imageType === 'small' ? '65px' : '100%')};
  height: ${({ imageType }) => (imageType === 'small' ? '65px' : 'auto')};
  margin: 0 auto;
  border-radius: ${themeStyle.radiusLarge};
`;

// H3 on desktop, H4 on mobile
export const ItemTitleWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;

  ${QUERIES.tabletAndUp} {
    margin-top: 24px;
    margin-bottom: 12px;
  }
`;

// P1 on desktop, P3 on mobile
export const Text = styled(P3)`
  color: ${themeStyle.varInkMedium};

  ${QUERIES.tabletAndUp} {
    font-size: ${themeStyle.fontSize16};
    line-height: 26px;
  }

  p {
    min-height: 1em;
    margin: 0px;
  }
`;
